import {
  GET_ALL_EWAY_TRANSACTION,
  ADD_EWAY_TRANSACTION,
  UPDATE_EWAY_TRANSACTION,
  UPDATE_STATUS_EWAY_TRANSACTION,
  DELETE_EWAY_TRANSACTION,
} from "../types";
import { setAlert } from "./alert";
import axios from "../../axios";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getAllEwayTransaction = () => async (dispatch) => {
  try {
    const res = await axios.get("eway-txn/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_ALL_EWAY_TRANSACTION, payload: res.data.data });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const addEwayTransaction = (formData, form) => async (dispatch) => {
  try {
    const res = await axios.post("eway-txn/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_EWAY_TRANSACTION, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message, // Only pass the message (string)
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "Warning!",
        text: res.data.message, // Only pass the message (string)
        icon: "warning",
      });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const updateEwayTransaction = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("eway-txn/update", formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_EWAY_TRANSACTION, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message, // Only pass the message (string)
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "Warning!",
        text: res.data.message, // Only pass the message (string)
        icon: "warning",
      });
    }
  } catch (error) {
    const errorMessage = getErrorMessage(error.response?.data);
    console.log("error :>> ", error);
    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

export const updateEwayTransactionStatus =
  (formData, form) => async (dispatch) => {
    try {
      const res = await axios.post("eway-txn/update/status", formData);
      if (res.data.code === 1) {
        dispatch({
          type: UPDATE_STATUS_EWAY_TRANSACTION,
          payload: res.data.data,
        });
        form.resetFields();
        Swal.fire({
          title: "Success!",
          text: res.data.message, // Only pass the message (string)
          icon: "success",
        });
      } else {
        Swal.fire({
          title: "Warning!",
          text: res.data.message, // Only pass the message (string)
          icon: "warning",
        });
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error.response?.data);

      Swal.fire({
        title: "Error!",
        text: errorMessage,
        icon: "error",
      });
    }
  };

export const deleteEwayTransaction = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`eway-txn/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_EWAY_TRANSACTION, payload: { id } });
      dispatch(setAlert(res.data.message, "success"));
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (error) {
    dispatch(setAlert(error.message, "danger"));
    const errorMessage = getErrorMessage(error.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
